// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"91c4ca11","186":"41fedba3","215":"225c4a75","372":"1308add0","377":"34b6e010","738":"f0108700","841":"7faf2222","851":"c2ed484e","856":"668dc9b6"}[chunkId] + ".chunk.js";
};